import channel from '../socket.ts'

const SOCKET_EVENTS = Object.freeze({
  UNREAD_MESSAGES_COUNT_UPDATED: 'unread_messages_count_updated'
})

const DOM_EVENTS = Object.freeze({
  UNREAD_MESSAGES_COUNT_UPDATED: 'unread_messages:count_updated'
})

const buildEvent = count => new CustomEvent(DOM_EVENTS.UNREAD_MESSAGES_COUNT_UPDATED, { detail: { count } })

if (channel) {
  const channelHandler = channel.on(SOCKET_EVENTS.UNREAD_MESSAGES_COUNT_UPDATED, ({ count }) => {
    const customEvent = buildEvent(count)
    document.documentElement.dispatchEvent(customEvent)
  })

  window.addEventListener('beforeunload', () => {
    channel.off(SOCKET_EVENTS.UNREAD_MESSAGES_COUNT_UPDATED, channelHandler)
  })
}

export { DOM_EVENTS as EVENTS, buildEvent }
